'use strict';

const Enum = require('./enum');

exports.DOORBELL_CALL_REDIS_KEY_PREFIX = 'DOORBELL:CALL:';
exports.DOORBELL_CALL_STATS_REDIS_KEY_PREFIX = 'DOORBELL:CALLSTATS:';
exports.DOORBELL_DVR_ID_REDIS_KEY_PREFIX = 'DOORBELLS:DVR:';
exports.DOORBELL_DVR_UPLOAD_PREFIX = 'DOORBELL_DVR_UPLOAD:';
exports.DOORBELL_ADD_RETRY_REDIS_KEY_PREFIX = 'DOORBELL:ADD_RETRY:';
exports.DOORBELL_ONLINE_REDIS_KEY_PREFIX = 'DOORBELL:ONLINE:';
exports.DOORBELL_CALLBACK_LOCK_REDIS_KEY_PREFIX = 'DOORBELL:CALLBACK:LOCK:';
exports.DOORBELL_OFFLINE_TIMES = 'DOORBELL:OFFLINE_TIMES:';
exports.DOORBELL_VIDEO_ENCODING_REDIS_KEY_PREFIX = 'AWS:ENCODING:';
exports.DOORBELL_VIDEO_ENCODING_STATS_REDIS_KEY_PREFIX = 'AWS:ENCODINGSTATS:';
exports.DOORBELL_VIDEO_ENCODING_JOB_DATA_REDIS_KEY_PREFIX = 'M3U:JOBDATA:';
exports.DOORBELL_VIDEO_ENCODING_FALLBACK_TIMER_REDIS_KEY_PREFIX = 'M3U:FALLBACKTIMER:';

exports.DOORBELL_PUBNUB_CHANNEL_GROUP = 'DOORBELL_PUBNUB_CHANNEL_GROUP';

exports.DOORBELL_OFFLINE = 'doorbell_offline';
exports.DOORBELL_OFFLINE_AND_NO_MORE_RETRIES = 'doorbell_offline_no_more_retries';

exports.DOORBELL_HEARTBEAT_CALL_STATS_KEY = 'mobileCallStats';

exports.CAMERA_USER_ID = 'camerauser';
exports.DOORBELL_CALL_DURATION_SECONDS = 30;

exports.DEFAULT_DOORBELL_SERIAL_NUMBER = '0';

exports.MARS_DOORBELL_REQUEST_VIDEO_UPLOAD = 'mars.doorbell.requestvideo.upload';

exports.DoorbellNotificationTypes = Object.create(Enum, {
  MOTION_DETECTED: { value: 'motiondetected', enumerable: true },
  VIDEO_AVAILABLE: { value: 'videoavailable', enumerable: true },
  BUTTON_PUSH: { value: 'buttonpush', enumerable: true },
});

exports.DoorbellPowerProfilePresets = Object.create(Enum, {
  CUSTOM: { value: -1, enumerable: true },
  DEFAULT: { value: 0, enumerable: true },
  // more levels to be added in the future
});

exports.DoorbellVersions = Object.create(Enum, {
  V1: { value: 'doorbell', enumerable: true },
  V2: { value: 'doorbell_v2', enumerable: true },
  V3: { value: 'doorbell_v3', enumerable: true },
  V4: { value: 'doorbell_v4', enumerable: true },
  V5: { value: 'doorbell_v5', enumerable: true },
  V6: { value: 'doorbell_v6', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
  parseType: {
    value: function(doorbellType) {
      switch (doorbellType) {
        case 1:
        case 'mars':
          return this.V1;
        case 'mars2':
          return this.V2;
        case 'hydra1':
          return this.V3;
        case 'eagle_indoor':
          return this.V4;
        case 'eagle_outdoor':
          return this.V5;
        case 'eagle_doorbell':
          return this.V6;
        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
  toType: {
    value: function(doorbellVersion) {
      switch (doorbellVersion) {
        case this.V1:
          return 'mars';
        case this.V2:
          return 'mars2';
        case this.V3:
          return 'hydra1';
        case this.V4:
          return 'eagle_indoor';
        case this.V5:
          return 'eagle_outdoor';
        case this.V6:
          return 'eagle_doorbell';
        default:
          return -1; // unknown
      }
    },
    enumerable: false,
  },
  getVersionFromDoorbellObject: {
    value: function(doorbell = {}) {
      // /!\ Because of an android bug we can't rely on the type in db
      // if (doorbell.type) {
      //   return this.parseType(doorbell.type);
      // }

      const serialNumber = (doorbell.serialNumber || '').toUpperCase();
      switch (true) {
        case serialNumber.startsWith('D1'):
          return this.V1;
        case serialNumber.startsWith('D2'):
          return this.V2;
        case serialNumber.startsWith('D3'):
          return this.V3;
        case serialNumber.startsWith('D4'):
          return this.V4;
        case serialNumber.startsWith('D5'):
          return this.V5;
        case serialNumber.startsWith('D6'):
          return this.V6;

        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
  getConfigurationModelName: {
    value: function(doorbell) {
      const doorbellVersion = this.getVersionFromDoorbellObject(doorbell);
      switch (doorbellVersion) {
        case this.V1:
          return 'devicesDoorbell';
        case this.V2:
          return 'doorbellV2Configuration';
        case this.V3:
          return 'doorbellV3Configuration';
        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
  hasClientCertificate: {
    value: function(doorbell) {
      const doorbellVersion = this.getVersionFromDoorbellObject(doorbell);

      return doorbellVersion === this.V3;
    },
    enumerable: false,
  },
  getCapabilities: {
    value: function(doorbell) {
      const doorbellVersion = this.getVersionFromDoorbellObject(doorbell);

      switch (doorbellVersion) {
        case this.V1:
          return {
            setupIP: '192.168.10.1',
            hasDock: false,
            hasFloodlight: false,
            canDisableWiredChime: false,
            supportsPowerModes: true,
            supportsImageQualityAdjustment: false,
            hasIntegratedBridge: true,
            supportsAugustChime: false,
            videoAspectRatio: '3x4',
            videoFormatOptions: ['480x640', '720x960', '960x1280'],
            batteryPoweredOnly: false,
            hasReplaceableFaceplate: false,
            motionSensitivityBounds: '64:224',
            minVoltage: 13.9,
            resetPatternType: 1,
            installationInstructionsUrl: '',
            troubleshootingUrl: 'http://august.com/kb-doorbell-cam-troubleshooting',
          };

        case this.V2:
          return {
            setupIP: '192.168.10.1',
            hasDock: true,
            hasFloodlight: true,
            canDisableWiredChime: true,
            supportsPowerModes: false,
            supportsImageQualityAdjustment: true,
            hasIntegratedBridge: true,
            supportsAugustChime: false,
            videoAspectRatio: '3x4',
            videoFormatOptions: ['480x640', '720x960', '960x1280'],
            batteryPoweredOnly: false,
            hasReplaceableFaceplate: false,
            motionSensitivityBounds: '32:224',
            minVoltage: 12.0,
            resetPatternType: 2,
            installationInstructionsUrl:
              'http://in-app-installation-guides.s3-website-us-west-2.amazonaws.com/prod/installation/dbc2',
            troubleshootingUrl: 'http://august.com/kb-doorbell-cam-pro-troubleshooting',
          };

        case this.V3:
          return {
            setupIP: '192.168.10.1',
            hasDock: false,
            hasFloodlight: false,
            canDisableWiredChime: false,
            supportsPowerModes: false,
            supportsImageQualityAdjustment: true,
            hasIntegratedBridge: false,
            supportsAugustChime: true,
            videoAspectRatio: '4x3',
            videoFormatOptions: ['640x480', '1280x960', '1920x1440'],
            batteryPoweredOnly: true,
            hasReplaceableFaceplate: true,
            motionSensitivityBounds: '32:224',
            minVoltage: 0, // TODO: Replace with actual value when product/hardware gives us a number.
            resetPatternType: 3,
            installationInstructionsUrl:
              'http://in-app-installation-guides.s3-website-us-west-2.amazonaws.com/prod/installation/dbc3/',
            troubleshootingUrl: 'http://august.com/kb-view-doorbell-cam-troubleshooting',
          };
      }
    },
    enumerable: false,
  },
});

exports.DoorbellSettingActions = Object.create(Enum, {
  REBOOT: { value: 'reboot', enumerable: true },
  SEND_SETTINGS: { value: 'send_settings', enumerable: true },
});

exports.DoorbellVideoUploadProgress = Object.create(Enum, {
  NOT_STARTED: { value: 'not_started', enumerable: true },
  IN_PROGRESS: { value: 'in_progress', enumerable: true },
  COMPLETE: { value: 'complete', enumerable: true },
});

exports.DoorbellEventReasons = Object.create(Enum, {
  MOTION: { value: 'MOTION', enumerable: true },
  PACKAGE: { value: 'PACKAGE', enumerable: true },
  HUMAN: { value: 'HUMAN', enumerable: true },
  PET: { value: 'PET', enumerable: true },
  VEHICLE: { value: 'VEHICLE', enumerable: true },
});

exports.DoorbellVideoFormats = Object.create(Enum, {
  MP4: { value: 'mp4', enumerable: true },
  TS: { value: 'ts', enumerable: true },
});

exports.NotificationModes = Object.create(Enum, {
  EFFICIENT: { value: 'efficient', enumerable: true },
  NORMAL: { value: 'normal', enumerable: true },
  RICH: { value: 'rich', enumerable: true },
});
